import React, { useState, useEffect } from 'react'
import axios from "axios"

const View = ({ tableData, isCsr }) => {
    const [view, setView] = useState(false)
    const [file, setFile] = useState('')
    const [ext, setExt] = useState('')

    useEffect(() => {
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const reviewFile = async (file) => {
        if (!file || typeof file !== 'string') {
            alert("Maaf, file tidak tersedia atau format salah.");
            return;
        }
        const file_name_array = file.split(".");
        const file_extension = file_name_array[file_name_array.length - 1];
        setExt(file_extension)
        setFile(file)
        getView()
    }

    const getView = () => {
        setView((prevState) => !prevState)
    }

    const displayView = {
        display: `${view ? "block" : "none"}`
    }

    const downloadLaporan = async (key) => {
        const response = await axios.get(`/api/laporan/publish/download/${key}`, { responseType: 'blob' });
        if (response.data.error) {
            console.error(response.data.error)
        }

        const fileURL = window.URL.createObjectURL(new Blob([response.data]));
        const fileLink = document.createElement('a');
        fileLink.href = fileURL;
        const contentDisposition = response.headers['content-disposition'];
        const fileName = contentDisposition.substring(
            contentDisposition.indexOf('filename=') + 9,
            contentDisposition.length
        );
        fileLink.setAttribute('download', fileName);
        fileLink.setAttribute('target', '_blank');
        document.body.appendChild(fileLink);
        fileLink.click();
        fileLink.remove();
    }

    const downloadFileCsr = (fullUrl) => {
        try {
            if (!fullUrl) return alert("File tidak tersedia");

            // 1. Ambil nama folder dan file dari URL lengkap
            const urlParts = fullUrl.split('/');
            const folder = urlParts[urlParts.length - 2];
            const fileName = urlParts[urlParts.length - 1];

            // 2. Langsung arahkan lokasi browser ke endpoint backend
            // Browser akan langsung otomatis download tanpa ngebuka tab baru kosong
            window.location.href = `/api/csr/portal/download/${folder}/${fileName}`;

        } catch (err) {
            console.error("Download Error:", err);
            alert("Gagal mendownload file TJSL/CSR.");
        }
    }

    return (<>
        <div className="table-responsive">
            <table className="table">
                <thead>
                    <tr className="purple">
                        <th>No.</th>
                        {isCsr ? (
                            <>
                                <th>Tahun</th>
                                <th>OPD</th>
                                <th>Klaster</th>
                                <th>TJSL/CSR</th>
                                <th>Nilai</th>
                            </>
                        ) : (
                            <>
                                <th>Jenis</th>
                                <th>Subjenis</th>
                                <th>Periode</th>
                                <th>Waktu</th>
                            </>
                        )}
                        <th>Lihat</th>
                        <th>Download</th>
                    </tr>
                </thead>
                <tbody>
                    {tableData.map((val, index) => (
                        <tr key={index}>
                            <td width="5%">{index + 1}</td>
                            {isCsr ? (
                                <>
                                    <td width="10%">
                                        {isCsr
                                            ? new Date(val.tgl_pengajuan).getFullYear() // Kalau TJSL, tampilin Tahunnya aja
                                            : val.periode // Kalau bukan TJSL, tampilin field periode bawaan API
                                        }
                                    </td>
                                    <td width="20%">
                                        {val.opd_id && val.opd_id.nama_opd ? val.opd_id.nama_opd : '-'}
                                    </td>
                                    <td width="20%">{val.klaster}</td>
                                    <td width="15%">
                                        {val.nama_program ? val.nama_program : '-'}
                                    </td>
                                    <td width="15%">
                                        {val.nilai_csr ? `Rp ${val.nilai_csr.toLocaleString('id-ID')}` : 'Rp 0'}
                                    </td>
                                </>
                            ) : (
                                <>
                                    <td width="25%">{val.jenis}</td>
                                    <td width="25%">{val.subjenis}</td>
                                    <td width="15%">{val.periode}</td>
                                    <td width="15%">{val.waktu}</td>
                                </>
                            )}
                            <td width="7%">
                                <button onClick={() => reviewFile(isCsr ? val.gambar_design : val.url)} className="btn btn-raised btn-warning br-2 no-m">
                                    <i className="fa fa-eye no-m"></i>
                                </button>
                            </td>
                            <td width="8%">
                                {(isCsr ? val.rab_file : val.file) ? (
                                    <button
                                        onClick={() => isCsr ? downloadFileCsr(val.rab_file) : downloadLaporan(val.file)}
                                        className="btn btn-raised btn-primary br-2 no-m"
                                    >
                                        <i className="fa fa-download no-m"></i>
                                    </button>
                                ) : (
                                    // Kalo kosong, tampilin strip atau biarin kosong
                                    <span className="text-muted">-</span>
                                )}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
        {view ? (<>
            <div className={view ? ("modal-open") : ("")}>
                <div style={displayView} className={view ? 'modal modal-primary show' : 'modal modal-primary'} tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
                    <div className="modal-dialog review">
                        <div className="modal-content modal-md">
                            <div className="modal-header header-modal-primary p-1">
                                <h4 className="modal-title text-center" id="myModalLabel">Lihat File</h4>
                            </div>
                            <div className="modal-body">
                                {file && ext === 'pdf' ? (<iframe className='mb-2' width="100%" height="500" src={file} title="Preview File" alt="Preview File" />) : ("")}
                                {file && ext !== 'pdf' ? (<img className='mb-2' width="100%" src={file} title="Preview File" alt="Preview File" />) : ("")}
                                <button onClick={getView} className="btn btn-raised btn-primary br-2 no-m"><i className="fa fa-close"></i> Tutup</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>) : ''}
    </>)
}

export default View;